import { CSSProperties, DetailedHTMLProps, HTMLAttributes } from "react";

interface Props
  extends DetailedHTMLProps<HTMLAttributes<HTMLDivElement>, HTMLDivElement> {
  className?: string;
  style?: CSSProperties;
}
const Col: React.FC<React.PropsWithChildren<Props>> = ({
  children,
  className = "",
  style,
  ...otherProps
}) => {
  return (
    <div className={`col ${className}`} style={style} {...otherProps}>
      {children}
    </div>
  );
};

export default Col;
